import { useEffect, useState } from "react";
import { ShieldCheck } from "lucide-react";
import api from "../lib/api";
import { fmtDate } from "../lib/format";
import PageHeader from "../components/PageHeader";

export default function AuditLogs() {
  const [logs, setLogs] = useState([]);
  useEffect(() => { api.get("/audit-logs").then((r) => setLogs(r.data)).catch(() => {}); }, []);

  return (
    <div>
      <PageHeader title="Audit Logs" subtitle="Activity trail for compliance (Privacy Act 2020)" icon={ShieldCheck} />
      <div className="bg-white rounded-xl border border-slate-200 shadow-sm overflow-x-auto">
        <table className="w-full text-sm">
          <thead><tr className="border-b border-slate-100 bg-slate-50/60">
            {["Timestamp", "User", "Action", "Entity", "Entity ID"].map((h) => (
              <th key={h} className="text-left text-[11px] uppercase tracking-wider text-slate-500 font-semibold px-4 py-3 whitespace-nowrap">{h}</th>
            ))}
          </tr></thead>
          <tbody>
            {logs.length === 0 && <tr><td colSpan={5} className="px-4 py-12 text-center text-slate-400">No activity yet</td></tr>}
            {logs.map((l) => (
              <tr key={l.id} className="border-b border-slate-50 hover:bg-slate-50/60">
                <td className="px-4 py-3 text-slate-500">{new Date(l.timestamp).toLocaleString("en-NZ")}</td>
                <td className="px-4 py-3 font-medium text-navy-900">{l.user_name || "—"}</td>
                <td className="px-4 py-3"><span className="text-xs px-2 py-0.5 rounded-full bg-slate-100 text-slate-600">{l.action}</span></td>
                <td className="px-4 py-3 text-slate-600 capitalize">{l.entity}</td>
                <td className="px-4 py-3 text-slate-400 text-xs font-mono">{l.entity_id?.slice(0, 8) || "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
